<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getSidepanelTabNavigationContext } from 'src/components/Sidepanel/sidepanel-tab-navigation-context';
	import { TabId } from 'src/components/Sidepanel/sidepanel-types';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const navigationContext = getSidepanelTabNavigationContext();
	const isSidepanelContext = !!navigationContext;

	const goToMainControls = async () => {
		if (isSidepanelContext && navigationContext) {
			const mainTabIndex = navigationContext.getTabIndex(TabId.MAIN);

			if (mainTabIndex === -1) {
				console.warn('Main tab not found in tabs configuration');
				return;
			}

			setSidePanelState({ showSettingsModal: false });

			navigationContext.navigateToTab(TabId.MAIN);
		} else {
			navigateToSetting(device.id, 'main_controls', '', false);
		}
	};
</script>

<Alert
	class="mb-m"
	type="warning"
	heading={$format('alert_heading_away_mode_active', {
		default: 'Away Mode is Active',
	})}
	isHeadingBold
	message={$format('alert_message_away_mode_active', {
		default:
			'Away mode is currently enabled. All heating, ambient light, and schedules are disabled. To configure modes of operation, please disable away mode from the main controls.',
	})}
	cta={{
		title: capFirstChar(
			$format('button_go_to_main_controls', {
				default: 'Go to main controls',
			}),
		),
	}}
	on:cta_click={goToMainControls}
/>
